import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function GermanIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    height: "600",
    viewBox: "0 0 5 3",
    width: "1000"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: "3",
    width: "5",
    x: "0",
    y: "0"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D00",
    height: "2",
    width: "5",
    x: "0",
    y: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFCE00",
    height: "1",
    width: "5",
    x: "0",
    y: "2"
  }));
}